<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">市场管理</Breadcrumb-item>
        <Breadcrumb-item>兑换课程审核列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div>
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col :span="6">
            <Form-item  label="审核状态">
              <Select v-model="queryParams.auditStatus" clearable>
                <Option value="0" key="0">待审核</Option>
                <Option value="1" key="1">审核通过</Option>
                <Option value="2" key="2">审核不通过</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学生ID" :label-width="60">
              <Input placeholder="支持模糊搜索" name="uid" v-model="queryParams.uid"></Input>
            </Form-item>
          </Col>

          <Col :span="6">
            <Form-item label="学习导师" prop="studyAdviserId" :label-width="60">
              <AdminUserSelect
                adminGroupCode="userStudyAdviser"
                needDefaultStudyAdviser='0'
                transfer
                v-model="queryParams.studyAdviserId"
              ></AdminUserSelect>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="课程名称" :label-width="60">
              <Input placeholder="支持模糊搜索" name="courseName" v-model="queryParams.courseName"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="兑换记录序列号">
              <Input placeholder="支持范围查询:3,10" name="id" v-model="queryParams.id"></Input>
            </Form-item>
          </Col>
          <Col :span="8">
            <FormItem label="兑换时间" :label-width="60">
              <Row>
                <Col :span="11">
                  <DatePicker type="date" format="yyyy-MM-dd" placeholder="请选择开始日期"
                          @on-change="startTimeDateChange"
                          v-model="startTime" style="width: 100%;"></DatePicker>
                </Col>
                <Col :span="1" style="text-align: center;">-</Col>
                <Col :span="11">
                  <DatePicker type="date" format="yyyy-MM-dd" placeholder="请选择结束日期"
                          @on-change="endTimeDateChange"
                          v-model="endTime" style="width: 100%;"></DatePicker>
                </Col>
              </Row>
            </FormItem>
          </Col>
          <Col :span="2">
            <Button type="primary" icon="search" @click="search">搜索</Button>
          </Col>
        </Row>
      </Form>
      <Row class-name="export-wrap">
        <Col span="12">
          <div> <span>消耗课时：</span>{{statisticsSum.consumeTotal}}</div>
        </Col>
        <Col :span="12" class-name="export">
          <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search"
                  @click="exportData">导出
          </Button>
        </Col>
      </Row>
    </div>
    <List style="margin-top: 10px" :tableColumns="tableColumns" listUrl="/courseEx/list"
          :params="queryParams" :onLoading="onLoading" :reload="reload"></List>
    <LogicModal v-model="logicModal" :itemId="itemId" :value="logicModal"  :logicName="logicName"  :logicNumber="logicNumber" @on-close="logicModal = false" @on-edit-success="editSuccess"
                @on-edit-clearid="clearId"></LogicModal>
  </div>
</template>

<script>
  import LogicModal from './modal/LogicModal.vue';
import Row from 'iview/src/components/grid/row';

  export default {
    components: {
      LogicModal
    },
    data() {
      return {
        exportLoading: false,
        reload: 0,
        onLoading: false,
        logicModal: false,
        queryParams: {},
        statisticsSum: {
          consumeTotal: 0
        },
        startTime: '',
        endTime: '',
        itemId: null,
        logicName: null,
        logicNumber: null,
        tableColumns: [
          {
            title: '兑换记录序列号',
            width: 80,
            align: 'center',
            key: 'id'
          },
          {
            title: '课程名称',
            width: 200,
            align: 'center',
            key: 'name'
          },
          {
            title: '获得课时',
            width: 200,
            align: 'center',
            key: 'obtainNum'
          },
          {
            title: '兑换数量',
            width: 200,
            align: 'center',
            key: 'num'
          },
          {
            title: '学生ID、姓名',
            width: 180,
            render: (h, params) => {
              let row = params.row
              return h('a', {on: {click: () => this.openInfoModal(row.userId)}}, row.userId + '-' + row.nickname)
            }
          },
          {
            title: '手机号',
            width: 200,
            align: 'center',
            key: 'mobile',
            render: (h, params) => {
              return h('Poptip', {
                props: {
                  trigger: 'hover'
                }
              }, [
                h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3)
                  + "****" + params.row.mobile.substring(7) : params.row.mobile),
                // 当前行展示的数据
                h('div', {slot: 'content'}, params.row.mobile)
              ])
            }
          },
          {
            title: '学导',
            width: 100,
            key: 'studyAdviserName',
            render: (h, params) => {
              return h('span', params.row.studyAdviserName || '未分配')
            }
          },
          {
            title: '用户使用课时数',
            width: 200,
            align: 'center',
            key: 'userNum'
          },
          {
            title: '收货地址',
            width: 200,
            align: 'center',
            key: 'address'
          },
          {
            title: '审核状态',
            width: 200,
            align: 'center',
            key: 'auditStatus',
            render: (h, params) => {
              let row = params.row
              return h('div', row.auditStatus == 0 ? '待审核' : row.auditStatus == 1 ? "审核通过" : "审核不通过")
            }
          },
          {
            title: '审核人',
            width: 200,
            align: 'center',
            key: 'adminName'
          },
          {
            title: '快递公司',
            width: 200,
            align: 'center',
            key: 'logicName'
          },
          {
            title: '快递单号',
            width: 200,
            align: 'center',
            key: 'logicNumber'
          },
          {
            title: '创建时间',
            width: 200,
            align: 'center',
            key: 'gmtCreate'
          },
          {
            title: '更新时间',
            width: 200,
            align: 'center',
            key: 'gmtModified'
          },
          {
            title: '操作',
            width: 200,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              if (row.auditStatus == 0) {
                return h('div', [
                  h('a', {on: {click: () => this.pass(1, row.id)}}, '通过'),
                  h('span', ' / '),
                  h('a', {on: {click: () => this.pass(2, row.id)}}, '不通过')
                ])
              }
              if (row.auditStatus == 1) {
                return h('el-button', {
                  props: {type: 'primary', size: 'mini'},
                  on: {
                    click: () => {
                      this.onEdit(params.row)
                    }
                  }
                }, '编辑物流')
              }
              return ''
            }

          }
        ]
      }
    },
    mounted: function () {
      this.loadStatisticsSum()
    },
    created: function () {
    },
    methods: {
      loadStatisticsSum() {
        let self = this
        this.$http.post('/courseEx/sum', self.queryParams).then(function (res) {
          self.statisticsSum = res.data
        })
      },
      search() {
        this.startTime = this.queryParams.startGmtCreate
        this.endTime = this.queryParams.endGmtCreate
        this.reload = new Date().getTime()
        this.loadStatisticsSum()
      },
      editSuccess() {
        this.search();
      },
      clearId() {
        this.itemId = null
        this.logicName = null
        this.logicNumber = null
      },
      onEdit(row) {
        this.itemId = row.id
        this.logicName = row.logicName
        this.logicNumber = row.logicNumber
        this.logicModal = true
      },
      pass(val, id) {
        let self = this;
        self.$http.post('/courseEx/audit', {auditStatus: val, id: id}).then(res => {
          if (res) {
            self.$message.success('审核成功');
            self.search();
          }
        }).catch(err => {
          self.$message.error(err)
        })
      },
      openInfoModal(val) {
        this.uid = val
        let {href} = this.$router.resolve({
          name: 'userPayDetail',
          query: {uid: val, tabName: 0, parm: self.queryParams, backPath: '/user/UserExperienceList'}
        })
        window.open(href, '_blank')
      },
      exportData() {
        this.exportLoading = true
        this.$http.get('/courseEx/export', {responseType: 'arraybuffer', params: this.queryParams}).then((response) => {
          if (response.data) {
            let blob = new Blob([response.data], {type: 'text/csv'})
            let link = document.createElement('a')
            link.target = '_blank'
            link.href = window.URL.createObjectURL(blob)
            link.download = '兑换课记录.csv'
            link.click()
            this.exportLoading = false
          } else {
            this.$Message.error(response.msg)
          }
        }).catch((e) => {
          this.exportLoading = false
        })
      },
      startTimeDateChange(value) {
        this.queryParams.startGmtCreate = value
      },
      endTimeDateChange(value) {
        this.queryParams.endGmtCreate = value
      },
    },
    watch: {
      startGmtCreate(val) {
        this.startTime = val
      },
      endGmtCreate(val) {
        this.endTime = val
      }
    }


  }
</script>

<style scoped>
.export-wrap {
  margin-top: 24px;
}
.export {
  text-align: end;
}
</style>



// WEBPACK FOOTER //
// ExChangeRecordListB.vue?e3bc95d2